import React, { useState } from 'react';

import { type FilterIndex } from '@pkg/components/Sections/Profile/Filters';
import { useGetGroupCollections } from '@pkg/hooks';

import { CollectionsFilterContent } from './CollectionsFilterContent';

interface Props extends FilterIndex {
    height?: number;
}

export const GroupFilterCollections = ({ value, height = 160 }: Props) => {
    const [nameToFind, setNameToFind] = useState('');
    const { data, isError, isLoading, hasNextPage, fetchNextPage, isPreviousData, isFetchingNextPage, refetch } =
        useGetGroupCollections(nameToFind);

    return (
        <CollectionsFilterContent
            data={data}
            value={value}
            height={height}
            nameToFind={nameToFind}
            setNameToFind={setNameToFind}
            isError={isError}
            isLoading={isLoading}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            isPreviousData={isPreviousData}
            isFetchingNextPage={isFetchingNextPage}
            refetch={refetch}
        />
    );
};
